import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=81342c9e&scoped=true&"
import script from "./ItemCard.vue?vue&type=script&lang=ts&"
export * from "./ItemCard.vue?vue&type=script&lang=ts&"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=81342c9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81342c9e",
  null
  
)

export default component.exports